import Immutable from "immutable";

const getDefaultThemeColorsList = (dataGroupIndex = 0) => {
  const colorGroups = defaultBackgroundColorGroups;
  const noOfColorListsInGroup = Object.keys(colorGroups).length;
  return colorGroups[dataGroupIndex % noOfColorListsInGroup];
};

const getWhiteThemeColorsList = (dataGroupIndex = 0) => {
  const colorGroups = whiteBackgroundColorGroups;
  const noOfColorListsInGroup = Object.keys(colorGroups).length;
  return colorGroups[dataGroupIndex % noOfColorListsInGroup];
};

const getThemeColorsList = (dataGroupIndex = 0) => {
  const colorGroups = singleGroupBackgroundColorGroups;
  const noOfColorListsInGroup = Object.keys(colorGroups).length;
  return colorGroups[dataGroupIndex % noOfColorListsInGroup];
};

const defaultBackgroundColorGroups = {
  0: [
    "#29ff00",
    "#ff00a6",
    "#ff5d00",
    "#0cf",
    "#f9b9ff",
    "#f1ff00",
    "#f00",
    "#0053ff",
    "#ba00ff",
    "#81ffe6"
  ],
  1: [
    "#2b908f",
    "#90ee7e",
    "#f45b5b",
    "#7798BF",
    "#aaeeee",
    "#ff0066",
    "#eeaaee",
    "#55BF3B",
    "#DF5353",
    "#8085e9",
    "#ac3884"
  ],
  2: [
    "#82ffe6",
    "#e192ff",
    "#81aaff",
    "#ff8989",
    "#f8ff7c",
    "#c3c3c3",
    "#aaeeff",
    "#fcaa7c",
    "#ff71cd",
    "#9aff87"
  ],
  3: [
    "#b5c000",
    "#ad0e0e",
    "#466ec1",
    "#a737d0",
    "#00ab89",
    "#a84d18",
    "#ac3884",
    "#27a50f",
    "#6ba4b2",
    "#919191"
  ]
};

const whiteBackgroundColorGroups = {
  0: [
    "#7cb5ec",
    "#f7a35c",
    "#2b908f",
    "#7798BF",
    "#aaeeee",
    "#ff0066",
    "#eeaaee",
    "#55BF3B",
    "#DF5353",
    "#27a50f",
    "#81ffe6"
  ],
  1: [
    "#14a900",
    "#e900cc",
    "#ff6600",
    "#00aeff",
    "#f9b9ff",
    "#d7e300",
    "#ff0000",
    "#0053ff",
    "#ba00ff",
    "#00ffcc"
  ],
  2: [
    "#80dfcc",
    "#e192ff",
    "#81aaff",
    "#ff8989",
    "#cdd18a",
    "#c3c3c3",
    "#a6d9e6",
    "#fcaa7c",
    "#ff71cd",
    "#9aff87"
  ],
  3: [
    "#b5c000",
    "#ad0e0e",
    "#466ec1",
    "#a737d0",
    "#00ab89",
    "#a84d18",
    "#ac3884",
    "#27a50f",
    "#6ba4b2",
    "#919191"
  ]
};

const singleGroupBackgroundColorGroups = {
  0: [
    "#E66F96",
    "#827FE3",
    "#80dfcc",
    "#FCB3A3",
    "#175A7B",
    "#657AD2",
    "#F4928E",
    "#386BA9",
    "#F07F8D",
    "#00484C",
  ],
};

const safeColors = Immutable.OrderedSet.of(
    "#b47c00",
    "#ff9694",
    "#5a2200",
    "#f481ff",
    "#ffb850",
    "#c50082",
    "#a94a00",
    "#0174bd",
    "#02dc72",
    "#fc36e9",
    "#cad95e",
    "#009453",
    "#001225",
    "#ff7d1a",
    "#edff6e",
    "#60fcff",
    "#ff4683",
    "#52cb00",
    "#0c2c00",
    "#b0003f",
    "#272100",
    "#017c6e",
    "#a500c7",
    "#ffab85",
    "#007fae",
    "#a42c00",
    "#676e00",
    "#d9d5ff",
    "#87ff58",
    "#0135c9",
    "#720064",
    "#002c5d",
    "#ffe544",
    "#dc4b00",
    "#02aee0",
    "#a5c700",
    "#2b0015",
    "#ff8bc0",
    "#ffe7f3",
    "#01a505",
    "#bf0023",
    "#ffc377",
    "#005c2f",
    "#a0edff",
    "#4f0010",
    "#825bff",
    "#e1a6ff",
    "#726200",
    "#014ea7",
    "#95f210"
);

export {
  getThemeColorsList,
  getDefaultThemeColorsList,
  getWhiteThemeColorsList,
  safeColors
};
